import { Box, ButtonBase, Typography } from '@mui/material'
import { ChevronDown16Regular } from '@/components/Icon'
import styles from './ThreadsSection.module.scss'

export default function ThreadsSectionViewAllButton({ onClick }) {
  return (
    <ButtonBase type="button" className={styles.viewAllButton} aria-haspopup="dialog" onClick={onClick}>
      <Typography component="span" className={styles.viewAllLabel}>
        View all
      </Typography>
      <Box component="span" className={styles.viewAllChevron} aria-hidden>
        <ChevronDown16Regular />
      </Box>
    </ButtonBase>
  )
}
